// utils/backupStatus.js
export const mapBackupStatus = (status) => {
  // Convert Prisma enum values to frontend-friendly values
  const statusMap = {
    PENDING: "pending",
    IN_PROGRESS: "in_progress",
    COMPLETED: "completed",
    FAILED: "failed",
  };
  return statusMap[status] || status;
};

export const getStatusColor = (status) => {
  const normalizedStatus = mapBackupStatus(status);
  switch (normalizedStatus) {
    case "completed":
      return "success";
    case "in_progress":
      return "info";
    case "failed":
      return "error";
    case "pending":
      return "warning";
    default:
      return "default";
  }
};
